import React, { useEffect, useState,useCallback } from 'react';
import ContactForm from './ContactForm.tsx';
import { TbCurrencyDollar } from "react-icons/tb";
import { FaChevronDown, FaRegCircleCheck } from "react-icons/fa6";
import { useAuth } from "./AuthContext.tsx";
import './HomepageStyle.scss';
import { apiCall } from '../api/apiRoutes.ts';
import { message, Skeleton } from 'antd';
import { FaStethoscope } from "react-icons/fa6";
import { NetworkInfo } from "../constants/network.ts";
import showMessageQueue from '../utils/messageUtils.js';
const HomePage: React.FC = () => {
  const [newsData, setNewsData] = useState<any[]>([]);
  // const [catalogsData,setCatalogsData] = useState<any[]>([]); 
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { catalogData } = useAuth();
  const [clientId, setClientId] = useState(0);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [messages, contextHolder] = message.useMessage();

  const fetchNewsData = useCallback(async () => {
    try {
      setLoading(true);
      let data = {};
      const response:any = await apiCall(data,`${NetworkInfo.endpoints.news}`,"get",false,false,false);
      if (response?.success) {
        setNewsData(response?.data || []);
      } else {
        showMessageQueue(messages,"error",response?.message || "Failed to fetch news")
      }
    } catch (error) {
      console.error("Fetch News Data Error:", error);
      // messages.open({type: 'error',content: "An error occurred while fetching news."});
      showMessageQueue(messages,"error","An error occurred while fetching news")

    } finally {
      setLoading(false);
    }
  },[messages]);

  const fetchCatalogs = useCallback(async () => {
    try {
      let data = {};
      const response:any = await apiCall(data,`${NetworkInfo.endpoints.catalog}`,"get",false,false,false);
      if (response?.success) {
        // setCatalogsData(response?.data);
        catalogData(response?.data);
      } else {
      }
    } catch (error) {
      console.error("Fetch Catalogs Error:", error);
      // messages.open({type: 'error',content: "An error occurred while fetching catalogs."});
      showMessageQueue(messages,"error","An error occurred while fetching catalogs")

    } finally {
      setLoading(false);
    }
  },[catalogData,messages]);


  useEffect(() => {
    if (clientId && initialDataLoaded===false) {
      fetchNewsData();
      fetchCatalogs();
      setInitialDataLoaded(true)
    }
  }, [clientId,fetchNewsData,fetchCatalogs,initialDataLoaded]);

  useEffect(() => {
    const getClientIdFromLocalStorage = () => {
      try {
        let storedUser = localStorage.getItem("usmonUser");
        let parsedUser = storedUser ? JSON.parse(storedUser) : {};
        const currentClientId = Object.keys(parsedUser?.user?.current_client)[0];
        const newClientId = Number(currentClientId);

        if (!isNaN(newClientId) && newClientId !== clientId) {
          setClientId(newClientId);
        }
      } catch (error) {
        console.error("Error parsing localStorage or extracting clientId:", error);
      }
    };

    getClientIdFromLocalStorage();
    const handleStorageChange = () => {
      getClientIdFromLocalStorage();
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [clientId]);

  


  const toggleDropdown = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className='main-wrapper'>
      {contextHolder}
      <div className='container'>
        <div className='app-news-sec'>
          <h2>App News!</h2>
          <p>
            Read news and update messages from our app. If you want to upgrade your
            license, please contact us through our{' '}
            <a href="#contact-form">contact form below</a>.
          </p>

          <div className='app-news-boxes'>
            {loading ? (
              Array.from({ length: 3 }).map((_, index) => (
                <Skeleton key={index} active avatar paragraph={{ rows: 2 }} />
              ))
            ) : (
              newsData?.map((item, index) => (
                <div className='app-news-box' key={item.id}>
                  <span className='news-IconBox'>
                    {item?.serviceId===10001 ? <FaStethoscope className='icon-img'/>  : <TbCurrencyDollar className='icon-img' /> }
                    </span>
                  <div className='news-box-content'>
                    <h3>{item?.title}</h3>
                    <p>{item?.description}</p>
                    <div className='UpdateList-dropdown'>

                      {item.updates && (
                        <>
                         <button
                        className={`updateList-btn ${openIndex === index ? 'open' : ''}`}
                        onClick={() => toggleDropdown(index)}
                      >
                        UPDATE LIST <span className='updateList-icon'><FaChevronDown /></span>
                      </button>

                        <div className={`dropdown-content ${openIndex === index ? 'show' : ''}`}>
                          <ul className='dropdown-listbox'>
                            {item?.updates.split(', ').map((update: string, i: number) => (
                              <li className='dropdown-list' key={i}>
                                <span className='list-icon'><FaRegCircleCheck /></span> {update}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default HomePage;